import React, {useState, useContext, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { UNSAFE_NavigationContext as NavigationContext } from 'react-router-dom';

const NavigationPrompt = ({when, children}) => {
  const [nextLocation, setNextLocation] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const { navigator } = useContext( NavigationContext );
  const navigate = useNavigate();
  const unblock = useRef(null);

  useEffect( () => {
      if ( ! when ) return;
      unblock.current = navigator.block( ( tx ) => {
        if (when) {
          console.log('tx');
          console.log(tx);
          setOpenModal(true);
          setNextLocation(tx.location);
        }
        return !when;
      });
      return unblock.current;
  }, [ navigator, when ] );

  const onCancel = () => {
    setNextLocation(null);
    setOpenModal(false);
  }

  const onConfirm = () => {
    unblock.current();
    navigateToNextLocation();
  }

  const navigateToNextLocation = () => {
    navigate(nextLocation.pathname);
  }
  return (
      <div>
        {children(openModal, onConfirm, onCancel)}
      </div>
    );
}


// const NavigationPromptWithNavigate = ({children, ...props}) => {
//   const navigate = useNavigate();
//   return(<NavigationPrompt navigate={navigate} {...props}>{children}</NavigationPrompt>)
// }

// /**
//  * A replacement component for the react-router `Prompt`.
//  * Allows for more flexible dialogs.
//  *
//  * @example
//  * <NavigationPrompt when={this.props.isDirty}>
//  *   {(isOpen, onConfirm, onCancel) => (
//  *     <Modal show={isOpen}>
//  *       <div>
//  *         <p>Do you really want to leave?</p>
//  *         <button onClick={onCancel}>Cancel</button>
//  *         <button onClick={onConfirm}>Ok</button>
//  *       </div>
//  *     </Modal>
//  *   )}
//  * </NavigationPrompt>
//  */
// class NavigationPrompt extends React.Component
// {
//   constructor(props) {
//     super(props);
//     this.state = {nextLocation: null, openModal: false};
//     this.onCancel = this.onCancel.bind(this);
//     this.onConfirm = this.onConfirm.bind(this);
//   }

//   componentDidMount() {
//     this.unblock = this.props.history.block((nextLocation) => {
//       if (this.props.when) {
//         this.setState({
//           openModal: true,
//           nextLocation: nextLocation
//         });
//       }
//       return !this.props.when;
//     });
//   }

//   componentWillUnmount() {
//     this.unblock();
//   }

//   onCancel() {
//     this.setState({nextLocation: null, openModal: false});
//   }

//   onConfirm() {
//     this.navigateToNextLocation();
//   }

//   navigateToNextLocation() {
//     this.unblock();
//     this.props.navigate(this.state.nextLocation.pathname);
//   }

//   render() {
//     return (
//       <div>
//         {this.props.children(this.state.openModal, this.onConfirm, this.onCancel)}
//       </div>
//     );
//   }
// }

// NavigationPrompt.propTypes = {
//   when: PropTypes.bool.isRequired,
//   children: PropTypes.func.isRequired,
// };

export default NavigationPrompt;